import React, {useEffect, useRef, useState} from 'react';
import './ProductList.scss';

type Props = {
    sizeTank: number
    recommendedSizeTank: number|null
}

type Product = {
    id: number,
    name: string,
    regular_price: number
    sale_price: number|null
    image: string
    url: string
    show_my_water_badge: boolean
}

type ApiResponse = Array<Product>
function ProductList({sizeTank, recommendedSizeTank}: Props) {
    const [productsData, setProductsData] = useState<ApiResponse|undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(true);

    const refSizeTank = useRef();
    useEffect(() => {
        // console.log('Update', sizeTank);
        // console.log('refMinSizeTank', refSizeTank);

        if (refSizeTank.current == sizeTank) {
            return;
        }

        getApiData(sizeTank, recommendedSizeTank);

        // @ts-ignore
        refSizeTank.current = sizeTank;
    }, [sizeTank])

    // @ts-ignore
    const getApiData = async (sizeTank: number, recommendedSizeTank: number|null) => {
        setLoading(true);
        const reqHost = window.location.host == 'localhost:3000' ? 'http://localhost:8000/' : '/';
        let queryParams = "?size=" + sizeTank;
        if (recommendedSizeTank) {
            queryParams = queryParams + "&recommendedSize=" + recommendedSizeTank;
        }
        const data = await fetch(
            reqHost + "wp-json/rainwatercalculator/products" + queryParams
        ).then((response) => response.json());
        setProductsData(data);
        // console.log('setProductsData', data);
        setLoading(false);
    };

    const getFormattedPrice = (product: Product): React.ReactNode => {
        if (!product.sale_price) {
            return <span className={'price'}>{product.regular_price}zł</span>
        }

        return <span className={'price'}><s>{product.regular_price}zł</s> {product.sale_price}zł</span>
    }

    if (loading) {
        return <div className="ProductsList woocommerce">
            <div className='loading'>
                <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    }

    return (
        <div className="ProductsList woocommerce">
            <ul className={"row row-cols-1 row-cols-sm-2 row-cols-md-3"}>
                {productsData?.map(product => {
                    return <>
                        <li className={"col-sm product-item product"}>
                            <div className="container border">
                                <div className="top-container">
                                    {product.show_my_water_badge && <div className="my_water-badge">Moja Woda 2023</div>}
                                    <img src={product.image}/>
                                    <span>{product.name}</span>
                                </div>
                                <div className="bottom-container">
                                    {getFormattedPrice(product)}
                                    <div className={'shop-button'}>
                                        <a href={product.url} className={"yellow-button"} target={'_blank'}>Zobacz</a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        </>
                })}
            </ul>
        </div>
    );
}

export default ProductList;
